<template>
  <div class="contiguity-list">
    <h4>Powierzchnie dodatkowe</h4>

    <!-- Dodatkowe powierzchnie mieszkania -->
    <ul class="contiguity-list-ul" v-if="hasAdditionalAreas">
      <li v-if="item.balkon" class="contiguity-item"><strong>Balkon:</strong> {{ item.balkon }} m²</li>
      <li v-if="item.taras" class="contiguity-item"><strong>Taras:</strong> {{ item.taras }} m²</li>
      <li v-if="item.loggia" class="contiguity-item"><strong>Loggia:</strong> {{ item.loggia }} m²</li>
      <li v-if="item.ogrod" class="contiguity-item"><strong>Ogród:</strong> {{ item.ogrod }} m²</li>

      <!-- Lista contiguity -->
      <li
        v-for="cont in item.contiguity_list?.contiguity || []"
        :key="cont.contiguity_id"
        class="contiguity-item"
      >
        <strong>{{ cont.contiguity_name }}</strong>
        <span> – {{ cont.contiguity_type }}</span>
        <span v-if="cont.contiguity_area && Number(cont.contiguity_area) > 0">
          ({{ cont.contiguity_area }} m²)
        </span>

        <!-- Historia cen powiązana z daną powierzchnią -->
        <!-- <PriceHistory
          v-if="cont.contiguity_price_change_history"
          :url="cont.contiguity_price_change_history"
        /> -->
      </li>
    </ul>

    <div v-else>
      <p>Brak powierzchni dodatkowych</p>
    </div>
  </div>
</template>

<script>
// import PriceHistory from "./PriceHistory.vue";

export default {
  name: "ContiguityList",
  // components: { PriceHistory },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasAdditionalAreas() {
      return (
         (this.item.balkon && String(this.item.balkon).trim() !== "" && this.item.balkon !== "0") ||
      (this.item.taras && String(this.item.taras).trim() !== "" && this.item.taras !== "0") ||
      (this.item.loggia && String(this.item.loggia).trim() !== "" && this.item.loggia !== "0") ||
      (this.item.ogrod && String(this.item.ogrod).trim() !== "" && this.item.ogrod !== "0") ||
      (this.item.contiguity_list?.contiguity?.length > 0)
      );
    }
  }
};
</script>

<style scoped>
.contiguity-list {
  margin-top: 1rem;
}
.contiguity-list ul {
  list-style: none;
  padding: 0;
}
.contiguity-item {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}
</style>
